/** Reviews — «آراء العملاء» heading + the shared TestimonialCards. */
import React from 'react';
import TestimonialCards from '../../components/TestimonialsSection.jsx';
import { useStr } from './useStr.js';

export default function Reviews() {
  const { t } = useStr();
  return (
    <section className="sx">
      <div className="wrap">
        <div className="shead" id="reviews">
          <div>
            <div className="eb">{t('revEb')}</div>
            <h2 className="h">{t('revTitle')}</h2>
          </div>
        </div>
        <TestimonialCards />
      </div>
    </section>
  );
}
